// extracted by mini-css-extract-plugin
export default {"root":"vOWOvi53Xbrjq8g6VzPq","warn":"qU5L1QRMEpxcre0G0x8w","appIcon":"d7272FxuxuwasGBEMpdf","warnText":"mMdaR3gw2EUTBhdqrrsg","placeHolderShimmer":"ou0Rw4COiouzT1HNPIow"};